
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./restaurant.cjs.production.min.js')
} else {
  module.exports = require('./restaurant.cjs.development.js')
}
